<template>
    <ion-page>
        <ion-content :fullscreen="true" class="">
            <div class="relative h-screen flex overflow-hidden bg-white">
                <sidebar-menu />

                <div class="flex flex-col w-0 flex-1 overflow-hidden">
                    <main class="relative overflow-y-auto min-h-screen overflow-x-hidden">
                        <top-navigation
                        :title="title"
                        :showBack="showBack"
                        :backUrl="backUrl"
                        />

                        <slot></slot>
                    </main>
                </div>
            </div>
        </ion-content>
    </ion-page>
</template>

<script setup lang="ts">
import { 
    IonPage, 
    IonContent, 
} from '@ionic/vue';

import TopNavigation from '@/partials/TopNavigation.vue';
import SidebarMenu from '@/partials/SidebarMenu.vue';

defineProps ({
    title: String,
    backUrl: {
        type: String,
        default: null,
    },
    showBack: {
        type: Boolean,
        default: false,
    },
});

</script>